import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Alert from 'flarum/common/components/Alert';
import updateItemData from "../common/util/updateItemData";
import itemActualCost from "../common/util/itemActualCost";

export default class DecorationStorePurchaseSubscriptionModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    const {itemPurchaseData,purchaseExpired} = this.attrs;
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';
    const itemPurchaseCount = itemPurchaseData.purchase_count();
    const itemPurchaseActualCost = itemActualCost(itemPurchaseData,itemPurchaseCount);

    this.itemPurchaseData = itemPurchaseData;
    this.itemPurchaseCostText = moneyName.replace('[money]', itemPurchaseActualCost);
    this.itemData = itemPurchaseData.decorationData();
    this.itemStatus = itemPurchaseData.item_status();
    this.purchaseExpired = purchaseExpired;
    this.purchaseID = itemPurchaseData.id();
    this.updating = false;
    this.confirmationText = this.purchaseExpired===1?"ziven-decoration-store.forum.purchase-unsubscribe-confirmation":"ziven-decoration-store.forum.purchase-subscribe-confirmation";
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return this.itemData.item_title();
  }

  content() {

    return (
      <div className="Modal-body">
        <div className="Form">
          <div id="DecorationStoreConfirmationText" className="DecorationStoreConfirmationText">
            {app.translator.trans(this.confirmationText,{cost:this.itemPurchaseCostText})}
          </div>
          <div style="text-align:center">
            {Button.component(
              {
                className: 'Button decorationButton--green',
                disabled: this.updating,
                onclick: () => {
                  this.setSubscribeStatus();
                },
              },
              app.translator.trans('ziven-decoration-store.lib.confirm')
            )}&nbsp;
            {Button.component(
              {
                className: 'Button transferMoneyButton--gray',
                disabled: this.updating,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-decoration-store.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  setSubscribeStatus(){
    this.updating = true;

    const purchaseID = this.purchaseID;
    const purchaseExpired = this.purchaseExpired;

    app.request({
      url: `${app.forum.attribute('apiUrl')}/decorationStorePurchase/subscription`,
      method: 'POST',
      body: { purchaseID,purchaseExpired },
    })
    .then((payload) => {
        this.updating = false;
        this.itemPurchaseData.data.attributes.item_status = 0;
        this.itemPurchaseData.data.attributes.is_expired = purchaseExpired;
        
        if(this.itemStatus===1){
          updateItemData(this.itemPurchaseData);
        }
        
        m.redraw();
        this.hide();
      }
    );
  }
}
